// noinspection ES6UnusedImports

import $ from 'jquery';
import Mustache from 'mustache';
import L from 'leaflet';
import {__} from 'leaflet.markercluster';

export class MapsResultView {

    element;
    map;
    markerCluster;
    markers = [];
    infoWindow;

    greenIcon = new L.Icon({
        iconUrl: '/images/marker.png',
        shadowUrl: '/images/marker.png',
        iconAnchor:   [16, 40], // point of the icon which will correspond to marker's location
        popupAnchor:  [-2, -5] // point from which the popup should
    });

    constructor(element) {
        this.element = element;
        this.init();
    }

    init() {
        const mapConfig = window.__defaultMapConfig;
        this.map = L.map(this.element).setView([mapConfig.lat, mapConfig.lon], mapConfig.zoom);
        L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
            attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
            maxZoom: 18,
            id: 'mapbox/streets-v11',
            tileSize: 512,
            zoomOffset: -1,
            accessToken: 'pk.eyJ1IjoiZW5nZW5jeSIsImEiOiJjbDEyOGxzbmIwNGdrM2ptdnY1cXRhbHU0In0.H6i8dxgvYU_sXGsGL1B3-w'
        }).addTo(this.map);

        this.markerCluster = L.markerClusterGroup({
            zoomToBoundsOnClick: true,
            spiderLegPolylineOptions: {
                weight: 3,
                color: '#222',
                opacity: 0.5
            },
        });
        this.map.addLayer(this.markerCluster);
    }

    show() {
        $(this.element).show();
    }

    hide() {
        $(this.element).hide();
    }

    putActivities(data, viewType) {
        const locations = [];
        for (let index in data.data) {
            const item = data.data[index];
            locations.push({
                position: {
                    lat: item.lat,
                    lng: item.lon
                },
                data: item
            });
        }

        this.markerCluster.clearLayers();

        // create new markers
        this.markers = locations
            .filter(location => location.position.lat && location.position.lng)
            .map((location, i) => {

                const marker = L.marker([location.position.lat, location.position.lng], {icon: this.greenIcon})
                    .bindPopup(
                        Mustache.render($('#event-maps-window').html(), location.data),
                        {
                            minWidth: 250,
                            maxWidth: 250,
                            className: 'mos-map-popup'
                        }
                    );

                marker.on('mouseover', _ => {
                    marker.bindTooltip(location.data.title ?? location.data.name).openTooltip()
                });

                this.markerCluster.addLayer(marker);

                return marker;
            });
    }

    getSearchAttributes() {
        return {
            page: 1,
            perPage: 500
        };
    }

    bindFavoriteButton(callback) {
        // todo, implement
    }
}
